module.exports = __webpack_public_path__ + "img/event-2@2x.5f2882b9.png";